import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { msalInstance } from './config/msalConfig';
import { agenticMsalInstance } from './config/agenticMsalConfig';
import { queryClient } from './config/queryClient.ts';
import App from './App';
import './styles/index.css';
import { AppThemeProvider, ThemeModeProvider, useThemeMode } from './theme';
import legacyTheme from './theme/legacyTheme';
import darkTheme from './theme/darkTheme';
import { FEATURE_FLAGS } from './featureFlags';
import { ChatProvider } from './contexts/ChatContext';
import { MessageProvider } from './contexts/MessageContext';
import { NProgress } from "nprogress-v2";
import "nprogress-v2/dist/index.css";

NProgress.configure({ showSpinner: false });

const ThemedApp = ({ children }) => {
  const { mode } = useThemeMode();
  if (!FEATURE_FLAGS.newUI) {
    return <AppThemeProvider theme={legacyTheme}>{children}</AppThemeProvider>;
  }
  return (
    <AppThemeProvider theme={mode === 'dark' ? darkTheme : undefined}>
      {children}
    </AppThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

Promise.all([msalInstance.initialize(), agenticMsalInstance.initialize()]).then(() => {
  root.render(
    <QueryClientProvider client={queryClient}>
      <ThemeModeProvider>
        <ThemedApp>
          <ChatProvider>
            <MsalProvider instance={msalInstance}>
              <MessageProvider>
                <App />
              </MessageProvider>
            </MsalProvider>
          </ChatProvider>
        </ThemedApp>
      </ThemeModeProvider>
    </QueryClientProvider>,
  );
});
